import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/informes-sobre-impurezas-organicas")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/informes-sobre-impurezas-organicas", statusCode: 301 }); },
});
